import { BaseTableColumn } from "src/app/shared/models/app-models/BaseTableColumn.model"

export const testData: AuditChildTable[] = [
    {
        prefixTitle: "My Purchase Table > Item 1> ",
        mainTitle: "Item Budget",
        records: [
            {
                attribute: "Budget Type",
                before: "Operating",
                after: "Project"
            },
            {
                attribute: "Cost center",
                before: "ABC",
                after: "DEF"
            }
        ]
    },
    {
        prefixTitle: "My Purchase Table > Item 2> ",
        mainTitle: "Item Budget",
        records: [
            {
                attribute: "Budget Type",
                before: "Operating",
                after: "Project"
            },
            {
                attribute: "Cost center",
                before: "ABC",
                after: "DEF"
            }
        ]
    }
]
export interface AuditChildTable {
    prefixTitle: string
    mainTitle: string
    records: AuditChildRecord[]
}
export interface AuditChildRecord {
    attribute: string
    before: string
    after: string
}

export const auditChildColumns: BaseTableColumn<AuditChildRecord>[] = [
    {
        columnDef: 'attribute',
        header: 'Attribute',
        cell: (element: AuditChildRecord) => `${element.attribute}`,
    },
    {
        columnDef: 'before',
        header: 'Before',
        cell: (element: AuditChildRecord) => `${element.before}`,
    },
    {
        columnDef: 'after',
        header: 'After',
        cell: (element: AuditChildRecord) => `${element.after}`,
    }
];